<template>
  <v-card>
    <v-card-title>
      Data de exibição do sorteio no app
      <v-tooltip bottom max-width="300px">
        <template v-slot:activator="{ on }">
          <span v-on="on">
            <mf-icon class="help-icon ml-1" size="18">info</mf-icon>
          </span>
        </template>
        <span
          >Data em que o sorteio ficará visível no aplicativo. A data inicial da visibilidade do sorteio não pode ser anterior à data atual e permanecerá
          visível até uma semana após a data do sorteio do último prêmio.</span
        >
      </v-tooltip>
    </v-card-title>
    <v-card-text>
      <v-row>
        <v-col class="py-0">
          <mf-toggle v-model="raffle.available_in_app" label="Mostrar no aplicativo" class="pl-3" hide-details :disabled="isDisabled" @input="clearDates" />
        </v-col>
      </v-row>
      <v-row>
        <v-col cols="6">
          <mf-date-range-picker
            :key="componentKey"
            label="Data de exibição do sorteio no app"
            :initial-date.sync="raffle.app_start_exhibition_date"
            :final-date.sync="raffle.app_end_exhibition_date"
            :min="currentDate"
            dense
            :disabled="isDisabled || !raffle.available_in_app"
            :error-messages="errors.errorStartExhibitionDate"
            outlined
          />
        </v-col>
        <v-col cols="6">
          <mf-date-range-picker
            :key="`${raffle.start_date} - ${raffle.end_date}`"
            label="Data de vigência do sorteio"
            :initial-date="raffle.start_date"
            :final-date="raffle.end_date"
            dense
            disabled
            outlined
          />
        </v-col>
      </v-row>
      <v-row>
        <v-col class="py-0">
          <mf-info-card icon="info" :vHtml="dateInfoContent" />
        </v-col>
      </v-row>
    </v-card-text>
  </v-card>
</template>

<script>
import { mapState } from 'vuex'
import moment from 'moment-timezone'

export default {
  name: 'AppExhibitionDate',
  props: {
    isDisabled: {
      type: Boolean,
      required: true,
      default: false,
    },
    errors: {
      type: Object,
      required: true,
    },
  },
  data: function () {
    return {
      componentKey: 0,
    }
  },
  computed: {
    ...mapState({
      raffle: (state) => state.sorteio.raffle,
    }),
    currentDate() {
      return moment().format('YYYY-MM-DD')
    },
    dateInfoContent() {
      return '<span style="color: rgb(0, 77, 153)">A data de vigência do sorteio é calculada de acordo com a configuração de prêmios.</span>'
    },
  },
  watch: {
    'raffle.end_date': {
      handler() {
        if (this.raffle.end_date) {
          const maxExhibitionDate = moment(this.raffle.end_date).add(1, 'week')
          if (!this.raffle.app_end_exhibition_date || moment(this.raffle.app_end_exhibition_date).isBefore(maxExhibitionDate)) {
            this.raffle.app_end_exhibition_date = maxExhibitionDate.format('YYYY-MM-DD')
          }
        }
        this.componentKey += 1
      },
      immediate: true,
    },
  },
  methods: {
    clearDates(value) {
      if (!value) {
        this.raffle.app_start_exhibition_date = ''
        this.raffle.app_end_exhibition_date = ''
      }
    },
  },
}
</script>

<style lang="scss" scoped></style>
